import React from 'react'
import { t } from '@lingui/macro'
import { onHelpClick } from 'features/viewerPage/helpFunctions/onHelpClick'
import {
  Button,
  LoginIcon,
  RegisterIcon,
  SectionHeader,
  SolidsportIcon
} from 'pages/native/onBoarding/components'
import { useHistory } from 'react-router-dom'
import {
  NATIVE_PUBLIC_ROUTES,
  nativePublicPathGenerator
} from 'routes/native/PublicRoutes'

import { useCompanyName } from 'pages/native/onBoarding/context/OnBoardingContext'
import { useAnalytics } from 'utils/analytics/useAnalytics'

import styles from './Form.module.scss'

export const Form: React.FC = () => {
  const history = useHistory()
  const { value: companyName } = useCompanyName()
  const { trackClarity, trackGtm, anonId } = useAnalytics()

  React.useEffect(() => {
    if (!anonId) return
    trackClarity('anon_id_available', anonId)
    trackGtm('anon_id:available', { anon_id: anonId })
  }, [anonId, trackClarity, trackGtm])

  const handleGetStartedClick = () => {
    trackClarity('click_get_started_app')
    trackGtm('click_get_started_app')

    history.push(
      nativePublicPathGenerator(
        NATIVE_PUBLIC_ROUTES.ON_BOARDING.WELCOME,
        companyName
      )
    )
  }

  const handleLoginClick = () => {
    trackClarity('click_login_app')
    trackGtm('click_login_app')

    history.push(
      nativePublicPathGenerator(NATIVE_PUBLIC_ROUTES.AUTH.LOGIN, companyName)
    )
  }

  return (
    <div className={styles.Container}>
      <SectionHeader title={t`Welcome`} />
      <Button
        label={t`Get started`}
        icon={<RegisterIcon />}
        iconPosition="left"
        variant="filled"
        theme="primary"
        onClick={handleGetStartedClick}
      />
      <Button
        label={t`Login`}
        icon={<LoginIcon />}
        iconPosition="left"
        variant="outlined"
        theme="primary"
        onClick={handleLoginClick}
      />
      <Button
        variant="text"
        theme="support"
        onClick={() => onHelpClick()}
        label={
          <div className={styles.TextInline}>
            <span>{t`Need any help?`} </span>
            <span className={styles.ClickableText}>{t`Click here!`}</span>
          </div>
        }
      />
      <p className={styles.Tagline}>
        Powered by <SolidsportIcon />
      </p>
    </div>
  )
}
